import script from "./DashboardRestock.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardRestock.vue?vue&type=script&setup=true&lang=js"

import "./DashboardRestock.vue?vue&type=style&index=0&id=72c509ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c509ac"]])

export default __exports__